import { isApp, ShowConsentBannerUseCase } from '../core'
import { VisibilityAdapter } from '../adapters'

const hideConsentBannerPaths = [
  '/agb',
  '/datenschutz',
  '/impressum',
  '/datenschutzinformationen_otto_payments',
]

export const showConsentBannerUseCase = new ShowConsentBannerUseCase(
  new VisibilityAdapter(hideConsentBannerPaths, { isApp: isApp() }),
  isApp()
)
